import Box from "@mui/material/Box";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Stepper from "@mui/material/Stepper";
import Typography from "@mui/material/Typography";
import React, { useState } from "react";
import { ThreeDots } from "react-loader-spinner";
import { useNavigate } from "react-router-dom";
// Import React FilePond
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import { registerPlugin } from "react-filepond";

// Import the plugin code
import FilePondPluginImageResize from "filepond-plugin-image-resize";
import { Souscription } from "../../components/Raccordement/Souscription";
import { SouscriptionTest } from "../../components/Raccordement/SouscriptionTest";
import { ValidationRaccordement } from "../../components/Raccordement/ValidationRaccordement";
// Register the plugins
registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginImageResize
);
// eslint-disable-next-line import/first
// eslint-disable-next-line import/first
// eslint-disable-next-line import/first

const steps = [
  "Validation du raccordement",
  "Souscription à un forfait",
  "Test de confirmation",
];

const Validation = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [skipped, setSkipped] = useState(new Set());
  const [status, setStatus] = useState("encour")
  const [statusOk, setStatusOk] = useState("")

  // const isStepOptional = (step) => {
  //   return step === 1;
  // };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSkip = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const navigate = useNavigate();
  const [itentionInfos, setItentionInfos] = useState(null);
  const [filesRecuPaiement, setFilesRecuPaiement] = useState([]);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [adhesionChoix, setAdhesionChoix] = useState(null);
  const [stepper, setStepper] = useState("1");
  const [error, setError] = useState(null);
  const [loadingLocalisation, setLoadingLocalisation] = useState(false);
  const [navigTab, setNavigTab] = useState("eligible");
  const [startDate, setStartDate] = useState(new Date());
  const [paiementChoix, setPaiementChoix] = useState("MOMO");

  const [loadingPaiement, setLoadingPaiement] = useState(false);




  const handlePaiement = () => {
    setLoadingPaiement(true);
    setTimeout(() => {
      setLoadingPaiement(false);
      handleNext();
    }, 1000);
  };

  return (
    <div className="w-full  p-4">
      <button
        onClick={() => {
          window.history.back()
        }}
        className=" flex lg:hidden md:hidden xl:hidden bg-[#FF1D23]  md:mt-2 lg:mt-2 xl:mt-2 mt-16 px-2 py-1 text-white rounded-lg"
      >
        Quitter
      </button>
      <h1 className="lg:text-3xl md:text-3xl xl:text-3xl text-2xl font-extrabold mt-10 text-black mb-5">
        Processus de raccordement
      </h1>

      <div className="flex xl:flex-row lg:flex-row md:flex-row flex-col gap-8 h-full  md:w-[90%]  lg:w-[90%]  xl:w-[90%] w-full mx-auto  ">
        <div className="md:w-[20%]  lg:w-[20%]  xl:w-[20%] lg:h-[77.5vh] md:h-[77.5vh] xl:lg:h-[77.5vh] h- w-full flex flex-col justify-between pb-1">
          <div className=" hidden lg:block xl:block">
            <Stepper
              orientation="vertical"
              style={{ fontFamily: '' }}
              activeStep={activeStep}
            >
              {steps.map((label, index) => {
                const stepProps = {};
                const labelProps = {};

                if (isStepSkipped(index)) {
                  stepProps.completed = false;
                }
                return (
                  <Step key={label} {...stepProps}>
                    <StepLabel {...labelProps}>
                      <h2 className="font-medium">{label}</h2>
                    </StepLabel>
                  </Step>
                );
              })}
            </Stepper>
          </div>
          <div className=" md:hidden lg:hidden xl:hidden">
            <Stepper
              orientation="horizontal"
              style={{ height: "100%", width: "300px" }}
              activeStep={activeStep}
            >
              {steps.map((label, index) => {
                const stepProps = {};
                const labelProps = {};

                if (isStepSkipped(index)) {
                  stepProps.completed = false;
                }
                return (
                  <Step key={label} {...stepProps}>
                    <StepLabel {...labelProps}></StepLabel>
                  </Step>
                );
              })}
            </Stepper>
          </div>

          <button
            onClick={() => {
              window.history.back();
            }}
            className=" hidden lg:block md:block xl:block bg-[#FF1D23] px-2 py-1 text-white rounded-lg"
          >
            Quitter
          </button>
        </div>

        {activeStep === steps.length ? (
          // RECAP DES DIFFERENTS  ETAPES AVANT DE CLOTURER LE PROCESSUS
          <div className="flex flex-col w-[80%] h-[50vh] lg:h-[100vh] md:h-[77.5vh] xl:h-[77.5vh]   mx-auto justify-between">
            <Typography sx={{ mt: 2, mb: 1 }}>
              Toutes les étapes sont franchies - vous avez terminé,
              souhaiterez-vous clôturer le Processus?
            </Typography>

            <div className="flex flex-row justify-between mb-1">
              <button
                className={` py-1 px-2 ${activeStep === 0 ? "bg-[#7d7d7d] text-[#fff]" : "bg-blue-500"
                  }  text-white rounded-md`}
                disabled={activeStep === 0}
                onClick={handleBack}
              >
                Retour
              </button>
              <button
                className="py-1 px-2 font-medium rounded-lg bg-[#ffcb05]"
                onClick={() => navigate('/Raccordement')}
              >
                Confirmer
              </button>
            </div>
          </div>
        ) : (
          // FORMULAIRES DES DIFFERENTS  ETAPES
          <div className=" flex flex-col md:w-[70%] mb-4  lg:w-[70%] lg:h-[77vh] md:h-[77vh] xl:lg:h-[77vh] h- xl:w-[70%] w-[100%] justify-between ">
            <h2 className="lg:hidden lg:hhidden md:hhidden font-semibold">
              {activeStep === 0
                ? "validation du raccordement"
                : activeStep === 1
                  ? "Souscription à un forfait"
                  : activeStep === 2
                    ? "Test de confirmation"
                    : ""}
            </h2>

            {activeStep === 0 ? (
              <div className="w-full">
                <ValidationRaccordement setAdhesionChoix={setAdhesionChoix} setStatusOk={setStatusOk} />
              </div>
            ) : activeStep === 1 ? (
              <Souscription />
            ) : activeStep === 2 ? (
              <SouscriptionTest />
            ) : (
              null
            )}

            {/* DIV DE PAGINATION DU PROCESSUR */}

            <div className="w-full mx-auto mt-4">
              <hr />
              <div
                className="flex  mt-4"
                sx={{ display: "flex", flexDirection: "row", pt: 2 }}
              >
                <button
                  className={` py-1 px-2 ${activeStep === 0
                    ? "bg-[#7d7d7d] text-[#fff]"
                    : "bg-blue-500"
                    }  text-white rounded-md`}
                  disabled={activeStep === 0}
                  onClick={handleBack}
                >
                  Retour
                </button>
                <Box sx={{ flex: "1 1 auto" }} />
                {adhesionChoix !== null ? (
                  <div className="flex flex-row gap-2">
                    {adhesionChoix === "NonOK" && activeStep === 0 && (
                      <button
                        disabled={adhesionChoix === "OK"}
                        className="py-1 px-2 mx-2 font-medium rounded-lg bg-[#ffcb05]"
                        onClick={() => navigate('/Raccordement')}
                        sx={{ mr: 1 }}
                      >
                        Sauvegarder
                      </button>
                    )}

                    {adhesionChoix === "OK" && (
                      <button
                        // className="py-1 px-2 font-medium rounded-lg bg-[#a6a6a6]"
                        className="py-1 px-2 font-medium rounded-lg bg-[#ffcb05]"
                        onClick={activeStep === 1 ? handlePaiement : handleNext}
                      >
                        {activeStep === steps.length - 1 ? (
                          "Terminer"
                        ) : activeStep === 1 ? (
                          <span>
                            {!loadingPaiement ? (
                              "Suivant"
                            ) : (
                              <div className="flex flex-row items-center justify-center w-10">
                                <ThreeDots
                                  height="20"
                                  width="40"
                                  radius="9"
                                  color="#000"
                                  ariaLabel="three-dots-loading"
                                  wrapperStyle={{}}
                                  wrapperClassName=""
                                  visible={loadingPaiement}
                                />
                              </div>
                            )}
                          </span>
                        ) : (
                          "Poursuivre"
                        )}
                      </button>
                    )}
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        )
        }
      </div >
    </div >
  );
};

export default Validation;
